export default __webpack_public_path__ + "images/8G.d01b117.png";